<template>
    <q-dialog v-if="ready"
              v-model="modal"
              transition-show="scale"
              transition-hide="scale"
              :behavior="$q.platform.is.mobile ? 'menu' : 'default'"
              :maximized="$q.platform.is.mobile">
        <q-card class="modal-pickup-point">
            <div class="modal-header">
                <span class="modal-title">Пункты самовывоза</span>
                <div class="modal-close" @click="close">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
            </div>
            <q-card-section class="modal-content">
                <div v-if="!pickupPoints.length && !stores.length">
                    В выбранном населённом пункте нет доступных пунтов выдачи.
                </div>
                <div v-if="$q.platform.is.mobile"
                     class="desktop-category-tags q-mt-0">
                        <span class="tag-item cursor-pointer"
                              :class="{ 'selected': filters.indexOf('stores') !== -1 }"
                              @click="toggleFilter('stores')">Магазины К-С</span>
                    <span class="tag-item cursor-pointer"
                          :class="{ 'selected': filters.indexOf('pickup_points') !== -1 }"
                          @click="toggleFilter('pickup_points')">Пункты партнеров</span>
                </div>
                <ul class="modal-pickup-point-view">
                    <li class="nav-item">
                        <span @click="toggleViewMap()" class="nav-link" :class="{'active': viewMap}">Карта</span>
                    </li>
                    <li class="nav-item">
                        <span @click="toggleViewList()" class="nav-link" :class="{'active': viewList}">Список</span>
                    </li>
                    <li class="ml-auto">
                        <q-btn v-if="viewMap && selectedIndex !== null" color="primary" label="Применить" @click.prevent="setDeliveryPickupPoint()"></q-btn>
                    </li>
                </ul>
                <yandex-map
                    v-show="viewMap"
                    v-if="pickupPoints.length || stores.length"
                    :settings="mapSettings"
                    :coords="center"
                    :zoom="zoom"
                    :controls="['zoomControl', 'fullscreenControl']"
                    :cluster-options="clusterOptions"
                    @map-was-initialized="setMap">
                    <ymap-marker
                        v-for="(stores, index) in filteredStores"
                        :key="stores.id"
                        :marker-id="index"
                        marker-type="placemark"
                        :coords="[stores.lng, stores.lat]"
                        :hint-content="stores.name"
                        :icon="markerIconStore"
                        :properties="{
                            iconContent: index + 1,
                            hintContent: stores.address
                        }"
                        :callbacks="callbacks(index, 'store')"
                        cluster-name="1"
                    ></ymap-marker>
                    <ymap-marker
                        v-for="(pickupPoint, index) in filteredPickupPoints"
                        :key="pickupPoint.id"
                        :marker-id="index"
                        marker-type="placemark"
                        :coords="[pickupPoint.lng, pickupPoint.lat]"
                        :hint-content="pickupPoint.name"
                        :icon="markerIconPickupPoint"
                        :properties="{
                            iconContent: filteredStores.length + index + 1,
                            hintContent: pickupPoint.address
                        }"
                        :callbacks="callbacks(index, 'pickupPoint')"
                        cluster-name="1"
                    ></ymap-marker>
                </yandex-map>
                <div v-show="viewList"
                     class="nav-container d-flex flex-column"
                     :class="{ 'absolute': !this.$q.platform.is.mobile }">
                    <div class="desktop-category-tags px-3">
                        <span class="tag-item cursor-pointer"
                              :class="{ 'selected': filters.indexOf('stores') !== -1 }"
                              @click="toggleFilter('stores')">Магазины К-С</span>
                        <span class="tag-item cursor-pointer"
                              :class="{ 'selected': filters.indexOf('pickup_points') !== -1 }"
                              @click="toggleFilter('pickup_points')">Пункты партнеров</span>
                    </div>

                    <ol v-if="filteredPickupPoints.length || filteredStores.length" class="nav">
                        <li v-for="(store, index) in filteredStores" class="nav-item" :id="'store-' + index + '-details'">
                            <span class="nav-link" @click="toggleStore(index)">
                                {{ store.name }}
                            </span>
                            <div v-if="(selectedType === 'stores') && (selectedIndex === index)">
                                <span>{{ store.address }}</span>
                                <span>
                                <a :href="'tel: ' + store.contact_phone_number" class="link">{{ store.contact_phone_number }}</a></span>
                                <span>{{ store.work_time }}</span>

                                <q-btn color="primary" v-if="withSelectButton" label="Применить" @click.prevent="setDeliveryPickupPoint(store)" class="mt-2"></q-btn>
                            </div>
                        </li>
                        <li v-for="(pickupPoint, index) in filteredPickupPoints" class="nav-item" :id="'pickup-point-' + index + '-details'">
                            <span class="nav-link" @click="togglePickupPoint(index)">
                                {{ pickupPoint.name }}
                            </span>
                            <div v-if="(selectedType === 'pickupPoints') && (selectedIndex === index)">
                                <span>{{ pickupPoint.address }}</span>
                                <span>
                                <a :href="'tel: ' + pickupPoint.contact_phone_number" class="link">{{ pickupPoint.contact_phone_number }}</a></span>
                                <span>{{ pickupPoint.work_time }}</span>

                                <q-btn color="primary" v-if="withSelectButton" label="Применить" @click.prevent="setDeliveryPickupPoint(pickupPoint)" class="mt-2"></q-btn>
                            </div>
                        </li>
                    </ol>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';

export default {
    name: 'PickupPoints',
    components: { yandexMap, ymapMarker },
    data () {
        return {
            ready: false,
            map: null,
            center: [0, 0],
            zoom: 15,
            selectedType: null,
            selectedIndex: null,
            viewMap: true,
            viewList: !this.$q.platform.is.mobile,
            filters: [],
            clusterOptions: {
                1: {
                    clusterDisableClickZoom: false,
                    clusterOpenBalloonOnClick: true,
                },
            },
            markerIconStore: {
                layout: 'default#image',
                imageHref: '/img/svg/map_store.svg',
                imageSize: [40, 40],
                imageOffset: [-20, -40]
            },
            markerIconPickupPoint: {
                layout: 'default#image',
                imageHref: '/img/svg/map_pickup.svg',
                imageSize: [40, 40],
                imageOffset: [-20, -40]
            }
        }
    },
    watch: {
        modal (newVal) {
            if (newVal) {
                if (this.pickupPoints.length) {
                    this.ready = true;
                } else {
                    this.init();
                }
            } else {
                if (this.selectedType && this.selectedIndex) {
                    this.setDeliveryPickupPoint(this[this.selectedType][this.selectedIndex]);
                }

                this.ready = false;
            }
        },
        pickupPoints () {
            this.update();
        },
        stores () {
            this.update();
        },
        map () {
            this.update();
        }
    },
    methods: {
        init () {
            let _this = this;

            axios.get('/deliveries/pickup-points')
                .then(response => {
                    _this.$store.commit('delivery/setPickupPoints', response.data.pickupPoints);
                    _this.$store.commit('delivery/setStores', response.data.stores);

                    this.ready = true;
                })
        },

        update () {
            let _this = this;

            _this.clearSelected();

            if ((_this.pickupPoints.length || _this.stores.length) && _this.map) {
                this.$nextTick(function () {
                    setTimeout(function () {
                        let bounds = _this.map.geoObjects.getBounds();
                        if (bounds) {
                            _this.map.setBounds(bounds, {checkZoomRange:true});
                        }
                    }, 200);
                });
            }
        },

        clearSelected () {
            this.selectedType = null;
            this.selectedIndex = null;
        },

        toggleStore (index) {
            if ((this.selectedType === 'stores') && (this.selectedIndex === index)) {
                this.selectedType = null;
                this.selectedIndex = null;
            } else {
                this.selectedType = 'stores';
                this.selectedIndex = index;
            }

            this.map.setZoom(17);
            this.map.panTo([this.stores[index].lng, this.stores[index].lat], {flying: true, duration: 1000});
        },

        togglePickupPoint (index) {
            if ((this.selectedType === 'pickupPoints') && (this.selectedIndex === index)) {
                this.selectedType = null;
                this.selectedIndex = null;
            } else {
                this.selectedType = 'pickupPoints';
                this.selectedIndex = index;
            }

            this.map.setZoom(17);
            this.map.panTo([this.pickupPoints[index].lng, this.pickupPoints[index].lat], {flying: true, duration: 1000});
        },

        setMap (map) {
            this.map = map;
        },

        callbacks (index, type) {
            let _this = this;

            return {
                click: function () {
                    if (type === 'store') {
                        document.getElementById('store-' + index + '-details').scrollIntoView();

                        _this.toggleStore(index);
                    } else {
                        document.getElementById('pickup-point-' + index + '-details').scrollIntoView();

                        _this.togglePickupPoint(index);
                    }
                }
            }
        },

        selectCity () {
            this.$root.selectCity();
        },

        toggleViewMap () {
            this.viewMap = true;
            this.viewList = false;
        },

        toggleViewList () {
            this.viewMap = false;
            this.viewList = true;
        },

        setDeliveryPickupPoint () {
            if ((this.selectedType !== null) && (this.selectedIndex !== null)) {
                let point = this[this.selectedType][this.selectedIndex];

                if(['pickupPoints', 'stores'].includes(this.selectedType)) {
                    this.$store.commit('cart/setFormValue', {
                        key: 'delivery_method_id',
                        value: this.selectedType === 'pickupPoints' ? 2 : 6,
                    });

                    this.$store.commit('cart/setFormValue', {
                        key: 'service_id',
                        value: point.delivery_service_id,
                    });

                    // need a little timeout, because looks like change of method/service causes pickup point clearance
                    setTimeout(() => {
                        this.$store.commit('cart/setFormValue', {
                            key: 'pickup_point_id',
                            value: point.id,
                        });
                    }, 150);
                }
            }

            this.modal = false;
        },

        toggleFilter (filter) {
            let index = this.filters.indexOf(filter);

            if (index !== -1) {
                this.filters.splice(index, 1);
            } else {
                this.filters.push(filter);
            }
        },
        close() {
            if (this.selectedIndex && this.withSelectButton) {
                this.update();
                this.$store.commit('delivery/hidePickupPointsModal');
                setTimeout(() => {
                    this.$root.showPickupPoints(true);
                }, 150);
            } else {
                this.modal = false;
            }
        }
    },
    computed: {
        ...mapState('geo', [
            'location',
        ]),
        ...mapState('delivery', [
            'stores',
            'pickupPoints',
            'withSelectButton',
            'mapSettings',
        ]),
        cityLabel () {
            return this.location.city
                ? this.location.city.type_short + '. ' + this.location.city.name
                : '';
        },
        pickupPointsCenter () {
            if (!this.pickupPoints.length && !this.stores.count) {
                return [54.989342, 73.368212];
            }

            return [
                (_.sumBy(this.pickupPoints, 'lng') + _.sumBy(this.stores, 'lng')) / (this.pickupPoints.length + this.stores.length),
                (_.sumBy(this.pickupPoints, 'lat') + _.sumBy(this.stores, 'lat')) / (this.pickupPoints.length + this.stores.length),
            ];
        },
        modal: {
            get () {
                return this.$store.state.delivery.pickupPointsModal;
            },

            set (value) {
                this.$store.commit('delivery/hidePickupPointsModal');
            }
        },
        filteredStores () {
            if (!this.filters.length || (this.filters.indexOf('stores') !== -1)) {
                return this.stores;
            }

            return [];
        },
        filteredPickupPoints () {
            if (!this.filters.length || (this.filters.indexOf('pickup_points') !== -1)) {
                return this.pickupPoints.filter(pickupPoint => pickupPoint.delivery_service_id !== 1);
            }

            return [];
        }
    }
}
</script>
